const navigation = [
  {
    to: '/',
    name: 'Dashboard',
    icon: 'fa-solid fa-chart-line',
    exact: true,
  },
  {
    to: '/administradores',
    name: 'Administradores',
    icon: 'fas fa-user-cog',
  },
  {
    to: '/profissionais',
    name: 'Profissionais',
    icon: 'fas fa-user-tie',
  },
  {
    to: '/clientes',
    name: 'Clientes',
    icon: 'fas fa-user',
  },
  {
    to: '/fornecedores',
    name: 'Fornecedores',
    icon: 'fa-solid fa-building-user',
  },

  {
    to: '/especialidades',
    name: 'Tipo de Atendimentos',
    icon: 'fa-solid fa-layer-group',
  },
  {
    to: '/grupos',
    name: 'Grupos',
    icon: 'fa-solid fa-users-rectangle',
  },
  {
    to: '/salas-atendimentos',
    name: 'Salas de Atendimentos',
    icon: 'fa-brands fa-buromobelexperte',
  },
  {
    type: 'submenu',
    name: 'Tabelas de Valores',
    icon: 'fa-solid fa-table',
    items: [
      {
        to: '/tabela-valores-especialistas',
        name: 'Tabela Especialistas',
        icon: 'fa-solid fa-table',
      },
      {
        to: '/tabela-valores-clientes',
        name: 'Tabela Clientes',
        icon: 'fa-solid fa-table',
      },
    ],
  },
  {
    type: 'submenu',
    name: 'Financeiro',
    icon: 'fa-solid fa-file-invoice-dollar',
    items: [
      /* {
        to: '/contas-pagar',
        name: 'Contas a Pagar',
        icon: 'fa-solid fa-file-invoice-dollar',
      }, */
      {
        to: '/contas-pagar-agrupado',
        name: 'Contas a Pagar',
        icon: 'fa-solid fa-file-invoice-dollar',
      },
      {
        to: '/contas-receber-agrupado',
        name: 'Contas a Receber',
        icon: 'fa-solid fa-file-invoice-dollar',
      },
      {
        to: '/lancamentos-administrativos',
        name: 'Lançamentos Administrativos',
        icon: 'fa-solid fa-list-alt',
      },
      {
        to: '/nicash-reembolsos',
        name: 'Reembolsos/Cartão Corporativo',
        icon: 'fa-solid fa-money-check-dollar',
      },
    ],
  },
  {
    to: '/relatorios',
    name: 'Relatórios',
    icon: 'fa-solid fa-file-invoice',
  },
];

export default navigation;
